export const getTrackingLabel = ({
  contentKey,
  isScreenName,
}: {
  contentKey: string
  isScreenName?: boolean
}) => contentKey.split('.')[isScreenName ? 1 : 2]
